import { Link } from 'react-router-dom';
// import LogoDark from '/images/logos/Logo.png';
import { styled } from '@mui/material';
import { useSelector } from 'react-redux';
import getImage from '../../assets/images/Logo.png'
import getNayab from '../../assets/images/nayab2.png'


const Logo = (props) => {
  const url = useSelector((state)=>state.Api.imageServer)
  const WebSrn = localStorage.getItem('WebSrn')

  const LinkStyled = styled(Link)(() => ({
    height: '80px',
    width: props.width ? props.width : '290px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  }));
  const LinkStyledNayab = styled(Link)(() => ({
    height: '150px',
    width: props.width ? props.width : '290px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
  }));
  return (<>
    {
    WebSrn == 14 ?
        <LinkStyledNayab>
               <img src={getNayab} alt="logo" height={150} />
        </LinkStyledNayab>
    :
    <LinkStyled>
      <img src={getImage} alt="logo" height={50} />
    </LinkStyled>
    }
</>
  )
};

export default Logo;
